module.exports = __webpack_public_path__ + "media/react/assets/images/small-logo-blue-b63060066bee274dcb769145ed7725d6.png";